import { defaultSorting, sortingValues } from './SortingValues';
import React from 'react';
import { SortingItem } from './Sorting.styles';
import { FilterableQueryParams } from 'models/FilterableQueryParams';
import { buildHref } from 'helpers/buildHref';
import { Icon } from '@trustedshops/tps-seo-shared-frontend-react-components';
import { OnParameterChange } from 'models/OnParameterChange';
import { FormattedMessage } from 'react-intl';
import { iconVariables } from 'styles/icon.variables';

export const handleSortingModalSelection = (
  selectedSort: string,
  activeFilters: FilterableQueryParams,
  onParameterChange: OnParameterChange
) => {
  const { pathname, query } = buildHref({
    ...activeFilters,
    sort: selectedSort !== defaultSorting ? selectedSort : undefined,
    page: undefined
  });

  onParameterChange({ pathname, query });
};

export const buildDropdownItems = (
  currentSort: string,
  activeFilters: FilterableQueryParams,
  onParameterChange: OnParameterChange
) => {
  /* istanbul ignore if */
  if (!currentSort) {
    return <></>;
  }

  return sortingValues.map((sort) => (
    <SortingItem
      key={sort}
      data-sort-item={sort}
      className={currentSort === sort ? 'active' : undefined}
      onClick={
        /* istanbul ignore next */ () =>
          handleSortingModalSelection(sort, activeFilters, onParameterChange)
      }
    >
      <FormattedMessage id={`SORTING.${sort.toUpperCase()}`} />
      {currentSort === sort && (
        <Icon
          iconName={'icon-feedback-check'}
          iconSize={iconVariables.SIZE_L}
          lineHeight={iconVariables.LINE_HEIGHT_REGULAR}
        />
      )}
    </SortingItem>
  ));
};
